// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .targetForm {
  background-color: #f6f3f3;
  padding-left: 20px;
}
.theme-light .targetForm .container {
  max-width: 500px;
  min-height: 1080px;
  margin: 50px auto;
  padding: 50px;
  background-color: white;
  color: #000;
  border-radius: 20px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
}
@media (max-width: 480px) {
  .theme-light .targetForm .container {
    padding: 20px;
    margin: 20px auto;
  }
}
@media (max-width: 960px) {
  .theme-light .targetForm .container {
    padding: 30px;
    margin: 30px auto;
  }
}
.theme-light .targetForm .container h2 {
  text-align: center;
  margin-bottom: 30px;
}
.theme-light .targetForm .container .error {
  color: red;
  margin-bottom: 15px;
  text-align: center;
}
.theme-light .targetForm .container .formGroup {
  margin-bottom: 25px;
  position: relative;
}
.theme-light .targetForm .container .formGroup label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #000;
}
.theme-light .targetForm .container .formGroup input,
.theme-light .targetForm .container .formGroup select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid;
  border-radius: 5px;
  background-color: transparent;
  color: #000;
}
.theme-light .targetForm .container .formGroup input:focus,
.theme-light .targetForm .container .formGroup select:focus {
  outline: none;
}
.theme-light .targetForm .container .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-light .targetForm .container .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-light .targetForm .container .buttons button:first-child {
  background-color: #5271ff;
}
.theme-light .targetForm .container .buttons button:last-child {
  background-color: #f0544f;
}
.theme-dark .targetForm {
  background-color: #333;
  padding-left: 20px;
}
.theme-dark .targetForm .container {
  max-width: 500px;
  min-height: 1080px;
  margin: 50px auto;
  padding: 50px;
  background-color: #222;
  color: #fffef9;
  border-radius: 20px;
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
}
@media (max-width: 480px) {
  .theme-dark .targetForm .container {
    padding: 20px;
    margin: 20px auto;
  }
}
@media (max-width: 960px) {
  .theme-dark .targetForm .container {
    padding: 30px;
    margin: 30px auto;
  }
}
.theme-dark .targetForm .container h2 {
  text-align: center;
  margin-bottom: 30px;
}
.theme-dark .targetForm .container .error {
  color: red;
  margin-bottom: 15px;
  text-align: center;
}
.theme-dark .targetForm .container .formGroup {
  margin-bottom: 25px;
  position: relative;
}
.theme-dark .targetForm .container .formGroup label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #fffef9;
}
.theme-dark .targetForm .container .formGroup input,
.theme-dark .targetForm .container .formGroup select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid;
  border-radius: 5px;
  background-color: transparent;
  color: #fffef9;
}
.theme-dark .targetForm .container .formGroup input:focus,
.theme-dark .targetForm .container .formGroup select:focus {
  outline: none;
}
.theme-dark .targetForm .container .buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.theme-dark .targetForm .container .buttons button {
  border: none;
  padding: 5px;
  color: white;
  cursor: pointer;
}
.theme-dark .targetForm .container .buttons button:first-child {
  background-color: #5271ff;
}
.theme-dark .targetForm .container .buttons button:last-child {
  background-color: #f0544f;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/target_form/targetForm.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;AAFJ;AAII;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EAGA,kDAAA;AAFN;AD4BE;ECpCE;IAaI,aAAA;IACA,iBAAA;EADN;AACF;AD2BE;ECzCE;IAkBI,aAAA;IACA,iBAAA;EAAN;AACF;AAEM;EACE,kBAAA;EACA,mBAAA;AAAR;AAGM;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;AADR;AAIM;EACE,mBAAA;EACA,kBAAA;AAFR;AAGQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AADV;AAIQ;;EAEE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;AAFV;AAIU;;EACE,aAAA;AADZ;AAOM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AALR;AAOQ;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AALZ;AAOY;EACA,yBAAA;AALZ;AAQY;EACA,yBAAA;AANZ;ADxDI;ECjBA,sBAAA;EACA,kBAAA;AA4EJ;AA1EI;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EAGA,kDAAA;AA4EN;ADlDE;ECpCE;IAaI,aAAA;IACA,iBAAA;EA6EN;AACF;ADnDE;ECzCE;IAkBI,aAAA;IACA,iBAAA;EA8EN;AACF;AA5EM;EACE,kBAAA;EACA,mBAAA;AA8ER;AA3EM;EACE,UAAA;EACA,mBAAA;EACA,kBAAA;AA6ER;AA1EM;EACE,mBAAA;EACA,kBAAA;AA4ER;AA3EQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA6EV;AA1EQ;;EAEE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;AA4EV;AA1EU;;EACE,aAAA;AA6EZ;AAvEM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAyER;AAvEQ;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAyEZ;AAvEY;EACA,yBAAA;AAyEZ;AAtEY;EACA,yBAAA;AAwEZ","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.targetForm {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n\n    .container {\n      max-width: 500px;\n      min-height: 1080px;\n      margin: 50px auto;\n      padding: 50px;\n      background-color: themed(\"bg\");\n      color: themed(\"textColor\");\n      border-radius: 20px;\n      -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n      -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n      box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n\n      @include mobile {\n        padding: 20px;\n        margin: 20px auto;\n      }\n\n      @include tablet {\n        padding: 30px;\n        margin: 30px auto;\n      }\n\n      h2 {\n        text-align: center;\n        margin-bottom: 30px;\n      }\n\n      .error {\n        color: red;\n        margin-bottom: 15px;\n        text-align: center;\n      }\n\n      .formGroup {\n        margin-bottom: 25px;\n        position: relative;\n        label {\n          display: block;\n          margin-bottom: 10px;\n          font-weight: 600;\n          color: themed(\"textColor\");\n        }\n\n        input,\n        select {\n          width: 100%;\n          padding: 12px 15px;\n          border: 1px solid themed(\"borderColor\");\n          border-radius: 5px;\n          background-color: transparent;\n          color: themed(\"textColor\");\n\n          &:focus {\n            outline: none;\n            border-color: themed(\"primaryColor\");\n          }\n        }\n      }\n\n      .buttons {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        flex-wrap: wrap;\n\n        button {\n            border: none;\n            padding: 5px;\n            color: white;\n            cursor: pointer;\n\n            &:first-child {\n            background-color: #5271ff;\n            }\n\n            &:last-child {\n            background-color: #f0544f;\n            }\n        }\n        }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
